import { render, staticRenderFns } from "./savedSearchPopup.vue?vue&type=template&id=08b4dbf8"
import script from "./savedSearchPopup.vue?vue&type=script&lang=js"
export * from "./savedSearchPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b4dbf8')) {
      api.createRecord('08b4dbf8', component.options)
    } else {
      api.reload('08b4dbf8', component.options)
    }
    module.hot.accept("./savedSearchPopup.vue?vue&type=template&id=08b4dbf8", function () {
      api.rerender('08b4dbf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/savedSearchPopup/savedSearchPopup.vue"
export default component.exports